import { DataMapName, pointers } from '@wix/thunderbolt-becky-types'
import { getEmptyDataMaps } from './utils'

const {
	data: {
		DATA_MAPS: { DATA, DESIGN, PRESETS, VARIANTS, CONNECTIONS },
	},
} = pointers
export const TEMPLATE_DATA_MAPS_TO_MERGE: Array<DataMapName> = [DATA, DESIGN, PRESETS, VARIANTS, CONNECTIONS]

export const RemoteRefDeadComp = 'RemoteRefDeadComp'
export const REMOTE_REF_DEAD_COMP = {
	structure: {
		RemoteRefDeadComp: {
			componentType: RemoteRefDeadComp,
			id: RemoteRefDeadComp,
			layout: {},
		},
	},
	originalStructure: {
		RemoteRefDeadComp: {
			componentType: RemoteRefDeadComp,
			id: RemoteRefDeadComp,
			layout: {},
		},
	},
	data: getEmptyDataMaps(),
	translations: {},
	rootId: RemoteRefDeadComp,
}

export { GHOST_COMP_STRUCTURE_OVERRIDES } from './byRefsis/constants'
